import React, { useCallback } from "react";
import Paragraph from "atoms/typography/paragraph";
import { t } from "utilities/localization-utils";
import useModalActions from "utilities/hooks/use-modal-actions";
import PublicationSelectionModal from "organisms/modals/publication-selection-modal/publication-selection-modal";
import usePublicationFavorites from "utilities/hooks/domain/user-publication-favorites/use-publication-favorites";
import UserPublicationFavoriteRecord from "models/view-models/user-publication-favorite-record";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";

const BASE_CLASS_NAME = "c-empty-mylink-panel";

const EmptyMyLinkPanel = () => {
    const { isOpen, handleClose, handleOpen } = useModalActions();
    const {
        favorites,
        setFavorites,
        refresh: refreshFavorites,
    } = usePublicationFavorites();

    const setAndRefreshFavorites = useCallback(
        (favorites: Array<UserPublicationFavoriteRecord>): void => {
            setFavorites(favorites);
            refreshFavorites();
        },
        [refreshFavorites, setFavorites]
    );

    return (
        <div className={BASE_CLASS_NAME}>
            <div
                className={`${BASE_CLASS_NAME}__mylink-info`}
                data-test-id="my-link--empty-my-link-panel--div">
                <Paragraph dataTestId="my-link--empty-my-link-panel--paragraph">
                    {t("myBookmarksTab-noBookmarksResultsBanner-title")}
                </Paragraph>
                <Button
                    dataTestId="my-link--empty-my-link-panel--view-all-publications-button"
                    onClick={handleOpen}
                    style={ButtonStyles.Anchor}>
                    {t("viewAllPublications")}
                </Button>
            </div>
            <PublicationSelectionModal
                isVisible={isOpen}
                favorites={favorites}
                onChangeFavorites={setAndRefreshFavorites}
                onResultClick={() => {}}
                closeDialog={handleClose}
            />
        </div>
    );
};

export default EmptyMyLinkPanel;
